import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onOpenAboutDialog = action("onOpenAboutDialog", event => ({
    event,
    owaType: "aboutDialog",
})) as OwaNovaActionUnion<"aboutDialog">;
